import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center gap-1.5" }
const _hoisted_2 = { class: "flex items-center gap-1.5" }

import type { SelectOption } from '@/types';
    import type { Table } from '@tanstack/vue-table';
    import {
        Select,
        SelectContent,
        SelectGroup,
        SelectItem,
        SelectTrigger,
        SelectValue,
    } from '@/components/ui/select';
    import { computed, ref } from 'vue';
    import { useI18n } from 'vue-i18n';
    import { toast } from 'vue-sonner';
    import type { AcceptableValue } from 'reka-ui';
    import Indicator from '@/components/Indicator.vue';
    import axios from 'axios';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'BulkStatusSelect',
  props: {
    table: {},
    options: {},
    dataFieldGroup: {},
    reportingPeriod: {},
    title: {}
  },
  setup(__props: any) {

    const { t } = useI18n();

    

    const props = __props;

    const title = computed(() => {
        return t(props.title);
    });

    const selectedValue = ref<AcceptableValue | null>(null);

    const companyIds = computed(() => {
        return props.table.getFilteredSelectedRowModel().flatRows.map((row) => row.original.id);
    });

    const hasSelectedRows = computed(() => {
        return companyIds.value.length > 0;
    });

    const routeName = computed(() => {
        return props.dataFieldGroup === 'vat_status'
            ? 'v2.dashboard.vat.bulk-update'
            : 'v2.dashboard.status.bulk-update';
    });

    const handleBulkUpdate = async () => {
        try {
            const selectedOption = props.options.find((opt) => opt.value === selectedValue.value);
            if (!selectedOption || !hasSelectedRows.value) return;

            await axios.post(route(routeName.value), {
                reporting_period: props.reportingPeriod,
                companies: companyIds.value,
                data_field_id: selectedOption.value,
                data_field_group: props.dataFieldGroup,
                data_field_approve: selectedOption.addon,
            });

            // Trigger a manual table refetch with loader in Dashboard
            window.dispatchEvent(new CustomEvent('dashboard-manual-refetch'));

            toast.success(
                t('dashboards.bulk_update_success', {
                    status: title.value,
                    count: companyIds.value.length,
                }),
            );
        } catch (error) {
            console.error('Failed to update status:', error);
            toast.error(t('dashboards.status_update_failed'));
        }
    };

    const handleSelectChange = (value: AcceptableValue) => {
        selectedValue.value = value;
        if (value) {
            handleBulkUpdate();
        }
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Select), {
    "model-value": selectedValue.value,
    "onUpdate:modelValue": handleSelectChange
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(SelectTrigger), { class: "data-[placeholder]:text-primary border shadow-none" }, {
        default: _withCtx(() => [
          _createVNode(_unref(SelectValue), null, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_1, _toDisplayString(title.value), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(SelectContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(SelectGroup), null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
                return (_openBlock(), _createBlock(_unref(SelectItem), {
                  key: option.value?.toString(),
                  value: option.value
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_2, [
                      _createVNode(Indicator, {
                        variant: option.color
                      }, null, 8, ["variant"]),
                      _createTextVNode(" " + _toDisplayString(option.label), 1)
                    ])
                  ]),
                  _: 2
                }, 1032, ["value"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})